<ng-container>
    <div class="user-dashboard-main container-fluid px-0">
        <div class="row g-3 align-items-start">
            <!-- SOL / ANA İÇERİK -->
            <div class="col-12 col-xl-9">
                <!-- HERO -->
                <section class="hero-panel">
                    <div class="hero-overlay">
                    </div>
                    <div class="hero-content">
                        <span class="hero-eyebrow">
                            ANAMETA ONE
                        </span>
                        <h1>
                            Hoşgeldin  <span>{{DashboardData.basic.helloName}}</span>,
                            <br>
                            başarı hikayeleri için iyi bir gün...
                        </h1>
                        <p>
                            İhtiyacınız olan uygulamaları seçin, projelerinizi oluşturun
                            <br>
                            ve tüm süreci tek bir yerden yönetin.
                        </p>
                        <div class="hero-actions">
                            <a routerLink="/projects/create" class="btn hero-primary">
                                Yeni Proje Oluştur
                                <i class="bi bi-plus-lg">
                                </i>
                            </a>
                            <a routerLink="/applications" class="btn hero-secondary">
                                Uygulamalara Göz At
                                <i class="bi bi-arrow-right">
                                </i>
                            </a>
                        </div>
                    </div>
                    <div class="hero-quote d-none d-lg-block">
                        <span class="quote-line">
                        </span>
                        <blockquote>
                            “Daha büyük
                            <br>
                            fikirler, daha parlak
                            <br>
                            yarınlar.”
                        </blockquote>
                    </div>
                </section>
                <!-- İSTATİSTİKLER -->
                <section class="row g-3 mt-0 stats-section">
                    <div class="col-12 col-md-6 col-xxl-3" *ngFor="let code of statCodes">
                        <article class="stat-card h-100">
                            <div
                                class="stat-icon"
                                [class.red]="code === 1"
                                [class.purple]="code === 2"
                                [class.orange]="code === 3"
                            >
                                <i
                                    class="bi"
                                    [class.bi-folder2-open]="code === 1"
                                    [class.bi-grid]="code === 2"
                                    [class.bi-clipboard-check]="code === 3"
                                >
                                </i>
                            </div>
                            <div class="stat-copy">
                                <div class="stat-head">
                                    <strong>
                                        {{ DashboardData.basic.totalProjects }}
                                    </strong>
                                    <span class="trend" [class.down]="Stat(code).trendDown">
                                        <i
                                            class="bi"
                                            [class.bi-arrow-up]="!Stat(code).trendDown"
                                            [class.bi-arrow-down]="Stat(code).trendDown"
                                        >
                                        </i>
                                        %{{ FormatNumber(Stat(code).trendPercent) }}
                                    </span>
                                </div>
                                <ng-container [ngSwitch]="code">
                                    <ng-container *ngSwitchCase="1">
                                        <span class="stat-title">
                                            Toplam Proje
                                        </span>
                                        <small>
                                            {{ FormatNumber(Stat(code).activeCount) }} aktif • {{ FormatNumber(Stat(code).completedCount) }} tamamlandı
                                        </small>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="2">
                                        <span class="stat-title">
                                            Kullanılan Uygulama
                                        </span>
                                        <small>
                                            Toplam {{ FormatNumber(Stat(code).totalCount) }} uygulama arasından
                                        </small>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="3">
                                        <span class="stat-title">
                                            Bekleyen Görev
                                        </span>
                                        <small>
                                            {{ FormatNumber(Stat(code).highPriorityCount) }} yüksek öncelik
                                        </small>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </article>
                    </div>
                    <div class="col-12 col-md-6 col-xxl-3">
                        <article class="stat-card h-100">
                            <div class="stat-icon health">
                                <i class="bi bi-activity">
                                </i>
                            </div>
                            <div class="stat-copy">
                                <div class="service-status">
                                    <span class="service-pill">
                                        <ng-container
                                            *ngIf="DashboardData.serviceStatus.totalCount > 0; else noService"
                                        >
                                            <ng-container *ngIf="allServicesActive; else partialServices">
                                                Tüm Sistemler Aktif
                                            </ng-container>
                                        </ng-container>
                                        <ng-template #noService>
                                            SERVİS YOK
                                        </ng-template>
                                        <ng-template #partialServices>
                                            Servis Durumu Kontrol Edilmeli
                                        </ng-template>
                                    </span>
                                    <i class="bi bi-chevron-right">
                                    </i>
                                </div>
                                <span class="stat-title">
                                    Servis Durumu
                                </span>
                                <small>
                                    <span class="online-dot" *ngIf="allServicesActive">
                                    </span>
                                    {{ FormatNumber(DashboardData.serviceStatus.activeCount) }}/{{ FormatNumber(DashboardData.serviceStatus.totalCount) }} servis çalışıyor
                                </small>
                            </div>
                        </article>
                    </div>
                </section>
                <!-- HIZLI ERİŞİM -->
                <section class="dashboard-panel quick-access-panel mt-3">
                    <div class="panel-header">
                        <h2>
                            Hızlı Erişim - Seçili Uygulamalarım
                        </h2>
                        <a routerLink="/applications">
                            Tüm Uygulamalarım
                            <i class="bi bi-arrow-right">
                            </i>
                        </a>
                    </div>
                    <div class="row g-2">
                        <div class="col-12" *ngIf="!DashboardData.applications.length">
                            <div class="dashboard-empty-state">
                                UYGULAMA YOK
                            </div>
                        </div>
                        <div class="col-6 col-md-4 col-lg" *ngFor="let app of DashboardData.applications">
                            <article class="app-card h-100">
                                <div class="app-info">
                                    <div class="app-logo" [ngClass]="ApplicationTheme(app.id)">
                                        <i [class]="ApplicationIcon(app.id)">
                                        </i>
                                    </div>
                                    <div class="app-copy">
                                        <strong>
                                            {{ ApplicationName(app.id) }}
                                        </strong>
                                        <small [ngSwitch]="app.typeCode">
                                            <ng-container *ngSwitchCase="1">
                                                PaaS / AI
                                            </ng-container>
                                            <ng-container *ngSwitchCase="2">
                                                SaaS / AR
                                            </ng-container>
                                            <ng-container *ngSwitchCase="3">
                                                SaaS
                                            </ng-container>
                                            <ng-container *ngSwitchCase="4">
                                                API
                                            </ng-container>
                                            <ng-container *ngSwitchCase="5">
                                                AI / NLP
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                0
                                            </ng-container>
                                        </small>
                                    </div>
                                </div>
                                <button
                                    type="button"
                                    class="open-app-button"
                                    (click)="openApplication(app)"
                                >
                                    Aç
                                    <i class="bi bi-arrow-right">
                                    </i>
                                </button>
                            </article>
                        </div>
                        <div class="col-6 col-md-4 col-lg">
                            <a routerLink="/marketplace" class="app-card add-app-card h-100">
                                <div class="add-circle">
                                    <i class="bi bi-plus-lg">
                                    </i>
                                </div>
                                <strong>
                                    Uygulama Ekle
                                </strong>
                                <small>
                                    Marketplace'i Keşfet
                                </small>
                            </a>
                        </div>
                    </div>
                </section>
                <!-- ALT BLOKLAR -->
                <div class="row g-3 mt-0">
                    <!-- SON PROJELER -->
                    <div class="col-12 col-xxl-7">
                        <section class="dashboard-panel projects-panel h-100">
                            <div class="panel-header">
                                <h2>
                                    Son Projelerim
                                </h2>
                                <a routerLink="/projects">
                                    Tüm Projelerim
                                    <i class="bi bi-arrow-right">
                                    </i>
                                </a>
                            </div>
                            <div *ngIf="!DashboardData.projects.length" class="dashboard-empty-state">
                                PROJE YOK
                            </div>
                            <div class="project-table" *ngIf="DashboardData.projects.length">
                                <div class="project-row project-head">
                                    <span>
                                        PROJE ADI
                                    </span>
                                    <span>
                                        UYGULAMA
                                    </span>
                                    <span>
                                        DURUM
                                    </span>
                                    <span>
                                        SON GÜNCELLEME
                                    </span>
                                    <span>
                                    </span>
                                </div>
                                <div class="project-row" *ngFor="let project of DashboardData.projects">
                                    <div class="project-name-cell">
                                        <img
                                            *ngIf="ProjectImage(project.id); else noProjectImage"
                                            [src]="ProjectImage(project.id)"
                                            [alt]="ProjectName(project.id)"
                                        >
                                        <ng-template #noProjectImage>
                                            <span class="dashboard-image-placeholder">
                                                0
                                            </span>
                                        </ng-template>
                                        <div>
                                            <strong>
                                                {{ ProjectName(project.id) }}
                                            </strong>
                                            <small>
                                                {{ ProjectDescription(project.id) }}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="project-app-cell">
                                        <span
                                            class="mini-app-logo"
                                            [ngClass]="ApplicationTheme(project.applicationId)"
                                        >
                                            <i [class]="ApplicationIcon(project.applicationId)">
                                            </i>
                                        </span>
                                        <span>
                                            {{ ApplicationName(project.applicationId) }}
                                        </span>
                                    </div>
                                    <div>
                                        <span
                                            class="status-pill"
                                            [class.green]="project.statusCode === 1 || project.statusCode === 4"
                                            [class.blue]="project.statusCode === 2"
                                            [class.orange]="project.statusCode === 3"
                                            [class.gray]="project.statusCode < 1 || project.statusCode > 4"
                                        >
                                            <ng-container [ngSwitch]="project.statusCode">
                                                <ng-container *ngSwitchCase="1">
                                                    Aktif
                                                </ng-container>
                                                <ng-container *ngSwitchCase="2">
                                                    Devam Ediyor
                                                </ng-container>
                                                <ng-container *ngSwitchCase="3">
                                                    Planlama
                                                </ng-container>
                                                <ng-container *ngSwitchCase="4">
                                                    Tamamlandı
                                                </ng-container>
                                                <ng-container *ngSwitchDefault>
                                                    0
                                                </ng-container>
                                            </ng-container>
                                        </span>
                                    </div>
                                    <div class="last-update">
                                        {{ RelativeDate(project.updatedAtUnix) }}
                                    </div>
                                    <button type="button" class="more-button">
                                        <i class="bi bi-three-dots">
                                        </i>
                                    </button>
                                </div>
                            </div>
                        </section>
                    </div>
                    <!-- ÖNERİLEN UYGULAMALAR -->
                    <div class="col-12 col-xxl-5">
                        <section class="dashboard-panel recommendations-panel h-100">
                            <div class="panel-header">
                                <h2>
                                    Sizin İçin Önerilen Uygulamalar
                                </h2>
                                <a routerLink="/marketplace">
                                    Tümünü Gör
                                    <i class="bi bi-arrow-right">
                                    </i>
                                </a>
                            </div>
                            <div class="row g-2">
                                <div class="col-12" *ngIf="!DashboardData.featuredApplications.length">
                                    <div class="dashboard-empty-state">
                                        ÖNERİLEN UYGULAMA YOK
                                    </div>
                                </div>
                                <div
                                    class="col-12 col-md-6"
                                    *ngFor="let featured of DashboardData.featuredApplications"
                                >
                                    <article
                                        class="featured-card"
                                        [style.background-image]="FeaturedBackground(featured.applicationId)"
                                    >
                                        <div class="featured-gradient">
                                        </div>
                                        <div class="featured-content">
                                            <strong>
                                                {{ ApplicationName(featured.applicationId) }}
                                            </strong>
                                            <p>
                                                {{ Display(applicationCatalog[featured.applicationId]?.description) }}
                                            </p>
                                            <div class="featured-footer">
                                                <div class="tags">
                                                    <span
                                                        *ngIf="!ApplicationTags(featured.applicationId).length"
                                                    >
                                                        ETİKET YOK
                                                    </span>
                                                    <span
                                                        *ngFor="let tag of ApplicationTags(featured.applicationId)"
                                                    >
                                                        {{ tag }}
                                                    </span>
                                                </div>
                                                <button
                                                    type="button"
                                                    (click)="OpenCatalogApplication(featured.applicationId)"
                                                    aria-label="Uygulamayı aç"
                                                >
                                                    <i class="bi bi-arrow-right">
                                                    </i>
                                                </button>
                                            </div>
                                        </div>
                                    </article>
                                </div>
                            </div>
                            <div class="market-title-row">
                                <h3>
                                    Marketplace'te Öne Çıkanlar
                                </h3>
                                <a routerLink="/marketplace">
                                    Tümünü Gör
                                    <i class="bi bi-arrow-right">
                                    </i>
                                </a>
                            </div>
                            <div class="row g-2">
                                <div class="col-12" *ngIf="!DashboardData.marketplaceHighlights.length">
                                    <div class="dashboard-empty-state">
                                        ÖNE ÇIKAN UYGULAMA YOK
                                    </div>
                                </div>
                                <div
                                    class="col-12 col-md-4"
                                    *ngFor="let item of DashboardData.marketplaceHighlights"
                                >
                                    <article class="market-mini-card h-100">
                                        <div
                                            class="market-mini-logo"
                                            [ngClass]="ApplicationTheme(item.applicationId)"
                                        >
                                            <i [class]="ApplicationIcon(item.applicationId)">
                                            </i>
                                        </div>
                                        <div>
                                            <strong>
                                                {{ ApplicationName(item.applicationId) }}
                                            </strong>
                                            <small>
                                                {{ Display(applicationCatalog[item.applicationId]?.description) }}
                                            </small>
                                            <span>
                                                {{ Display(ApplicationTags(item.applicationId)[0]) }}
                                            </span>
                                        </div>
                                    </article>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
            <!-- SAĞ PANEL -->
            <div class="col-12 col-xl-3">
                <div class="right-column">
                    <!-- HESAP -->
                    <section class="right-card account-card">
                        <div class="right-card-header">
                            <h2>
                                Hesap Bilgilerim
                            </h2>
                            <a routerLink="/profile">
                                Profili Düzenle
                                <i class="bi bi-arrow-right">
                                </i>
                            </a>
                        </div>
                        <div class="account-user">
                            <img
                                *ngIf="accountAvatar; else noAccountAvatar"
                                [src]="accountAvatar"
                                [alt]="accountName"
                            >
                            <ng-template #noAccountAvatar>
                                <span class="dashboard-avatar-placeholder">
                                    0
                                </span>
                            </ng-template>
                            <div>
                                <strong>
                                    {{ accountName }}
                                </strong>
                                <small>
                                    {{ accountEmail }}
                                </small>
                            </div>
                        </div>
                           <div class="usage-item">
                          
                            <div class="usage-label">
                                      <span>Abonelik</span> 
                                    <strong>
                                        {{ DashboardData.basic.subscriptionBeginDate }} /
                                        {{ DashboardData.basic.subscriptionEndDate }}
                                    </strong>
                                </div>
                                <div
                                    class="progress usage-progress"
                                    role="progressbar"
                                    aria-valuemin="0"
                                    [attr.aria-valuemax]="DashboardData.basic.maxProjectLimitsNumber ?? 0"
                                    [attr.aria-valuenow]="DashboardData.basic.currentProjectNumber ?? 0"
                                >
                                    <div
                                        class="progress-bar green"
                                        [style.width.%]="
                                            (DashboardData.basic.maxProjectLimitsNumber ?? 0) > 0 && (DashboardData.basic.currentProjectNumber ?? 0) > 0
                                                ? ((DashboardData.basic.currentProjectNumber ?? 0) >= (DashboardData.basic.maxProjectLimitsNumber ?? 0)
                                                    ? 100
                                                    : (DashboardData.basic.currentProjectNumber ?? 0) / (DashboardData.basic.maxProjectLimitsNumber ?? 0) * 100)
                                                : 0
                                        "
                                    ></div>
                                </div>
                            </div>
                        <div class="plan-row">
                            <div class="plan-left">
                                <span class="plan-icon">
                                    <i class="bi bi-stars">
                                    </i>
                                </span>
                                <div>
                                    <strong>
                                        {{ packageName }}
                                    </strong>
                                    <small>
                                        Daha fazla proje, daha fazla uygulama ile potansiyelini artır.
                                    </small>
                                </div>
                            </div>
                            <a routerLink="/plans">
                                Planı Yükselt
                                <i class="bi bi-arrow-right">
                                </i>
                            </a>
                        </div>
                      <div class="usage-list">
                            <div class="usage-item">
                                <div class="usage-label">
                                    <span>Proje Limiti</span>
                                    <strong>
                                        {{ DashboardData.basic.currentProjectNumber ?? 0 }} /
                                        {{ DashboardData.basic.maxProjectLimitsNumber ?? 0 }}
                                    </strong>
                                </div>
                                <div
                                    class="progress usage-progress"
                                    role="progressbar"
                                    aria-valuemin="0"
                                    [attr.aria-valuemax]="DashboardData.basic.maxProjectLimitsNumber ?? 0"
                                    [attr.aria-valuenow]="DashboardData.basic.currentProjectNumber ?? 0"
                                >
                                    <div
                                        class="progress-bar blue"
                                        [style.width.%]="
                                            (DashboardData.basic.maxProjectLimitsNumber ?? 0) > 0 && (DashboardData.basic.currentProjectNumber ?? 0) > 0
                                                ? ((DashboardData.basic.currentProjectNumber ?? 0) >= (DashboardData.basic.maxProjectLimitsNumber ?? 0)
                                                    ? 100
                                                    : (DashboardData.basic.currentProjectNumber ?? 0) / (DashboardData.basic.maxProjectLimitsNumber ?? 0) * 100)
                                                : 0
                                        "
                                    ></div>
                                </div>
                            </div>
                            <div class="usage-item">
                                <div class="usage-label">
                                    <span>Seçili Uygulama</span>
                                    <strong>
                                        {{ DashboardData.basic.currentApplicationNumber ?? 0 }} /
                                        {{ DashboardData.basic.maxApplicationLimitsNumber ?? 0 }}
                                    </strong>
                                </div>
                                <div
                                    class="progress usage-progress"
                                    role="progressbar"
                                    aria-valuemin="0"
                                    [attr.aria-valuemax]="DashboardData.basic.maxApplicationLimitsNumber ?? 0"
                                    [attr.aria-valuenow]="DashboardData.basic.currentApplicationNumber ?? 0"
                                >
                                    <div
                                        class="progress-bar purple"
                                        [style.width.%]="
                                            (DashboardData.basic.maxApplicationLimitsNumber ?? 0) > 0 && (DashboardData.basic.currentApplicationNumber ?? 0) > 0
                                                ? ((DashboardData.basic.currentApplicationNumber ?? 0) >= (DashboardData.basic.maxApplicationLimitsNumber ?? 0)
                                                    ? 100
                                                    : (DashboardData.basic.currentApplicationNumber ?? 0) / (DashboardData.basic.maxApplicationLimitsNumber ?? 0) * 100)
                                                : 0
                                        "
                                    ></div>
                                </div>
                            </div>
                            <div class="usage-item">
                                <div class="usage-label">
                                    <span>Aylık Kullanım</span>
                                    <strong>
                                        {{ DashboardData.basic.currentMonthlyUsableNumber ?? 0 }} /
                                        {{ DashboardData.basic.maxMonthlyUsableNumber ?? 0 }}
                                    </strong>
                                </div>
                                <div
                                    class="progress usage-progress"
                                    role="progressbar"
                                    aria-valuemin="0"
                                    [attr.aria-valuemax]="DashboardData.basic.maxMonthlyUsableNumber ?? 0"
                                    [attr.aria-valuenow]="DashboardData.basic.currentMonthlyUsableNumber ?? 0"
                                >
                                    <div
                                        class="progress-bar red"
                                        [style.width.%]="
                                            (DashboardData.basic.maxMonthlyUsableNumber ?? 0) > 0 && (DashboardData.basic.currentMonthlyUsableNumber ?? 0) > 0
                                                ? ((DashboardData.basic.currentMonthlyUsableNumber ?? 0) >= (DashboardData.basic.maxMonthlyUsableNumber ?? 0)
                                                    ? 100
                                                    : (DashboardData.basic.currentMonthlyUsableNumber ?? 0) / (DashboardData.basic.maxMonthlyUsableNumber ?? 0) * 100)
                                                : 0
                                        "
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <!-- 7 GÜN KULLANIM -->
                    <section class="right-card usage-card">
                        <div class="right-card-header usage-header">
                            <h2>
                                Son 7 Gün Kullanım
                            </h2>
                            <select class="form-select form-select-sm">
                                <option>
                                    Uygulamalar
                                </option>
                            </select>
                        </div>
                        <div *ngIf="!DashboardData.weeklyUsage.length" class="dashboard-empty-state">
                            HAFTALIK KULLANIM YOK
                        </div>
                        <div class="chart-wrap" *ngIf="DashboardData.weeklyUsage.length">
                            <div class="chart-y-axis">
                                <span>
                                    {{ FormatNumber(chartMaximum) }}
                                </span>
                                <span>
                                    {{ FormatNumber(chartMaximum / 2) }}
                                </span>
                                <span>
                                    0
                                </span>
                            </div>
                            <div class="chart-area">
                                <div class="grid-line top">
                                </div>
                                <div class="grid-line middle">
                                </div>
                                <div class="grid-line bottom">
                                </div>
                                <div
                                    class="bar-column"
                                    *ngFor="let item of DashboardData.weeklyUsage; let i = index"
                                >
                                    <div class="bar-tooltip" *ngIf="i === highlightedDayIndex">
                                        <strong>
                                            {{ FormatDate(item.dateUnix) }}
                                        </strong>
                                        <span>
                                            {{ FormatNumber(item.value) }} istek
                                        </span>
                                    </div>
                                    <div
                                        class="usage-bar"
                                        [class.highlight]="i === highlightedDayIndex"
                                        [style.height.px]="ChartHeight(item.value)"
                                    >
                                    </div>
                                    <span>
                                        {{ FormatShortDate(item.dateUnix) }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </section>
                    <!-- HABERLER -->
                    <section class="right-card news-card">
                        <div class="right-card-header">
                            <h2>
                                Duyurular ve Haberler
                            </h2>
                            <a routerLink="/announcements">
                                Tümünü Gör
                                <i class="bi bi-arrow-right">
                                </i>
                            </a>
                        </div>
                        <div *ngIf="!DashboardData.announcements.length" class="dashboard-empty-state">
                            DUYURU YOK
                        </div>
                        <article class="news-item" *ngFor="let news of DashboardData.announcements">
                            <img
                                *ngIf="NewsImage(news.id); else noNewsImage"
                                [src]="NewsImage(news.id)"
                                [alt]="NewsTitle(news.id)"
                            >
                            <ng-template #noNewsImage>
                                <span class="dashboard-image-placeholder">
                                    0
                                </span>
                            </ng-template>
                            <div>
                                <strong>
                                    {{ NewsTitle(news.id) }}
                                </strong>
                                <span>
                                    {{ FormatDate(news.publishedAtUnix) }}
                                </span>
                                <small>
                                    {{ NewsDescription(news.id) }}
                                </small>
                            </div>
                        </article>
                    </section>
                </div>
            </div>
        </div>
        <!-- ALT DUYURU ŞERİDİ -->
        <section class="announcement-strip mt-3">
            <div class="announcement-label">
                <i class="bi bi-megaphone-fill">
                </i>
                <strong>
                    Marketplace Duyurusu
                </strong>
            </div>
            <span class="footer-divider">
            </span>
            <div class="ticker-item" *ngIf="!DashboardData.announcements.length">
                DUYURU YOK
            </div>
            <div class="ticker-item" *ngFor="let news of DashboardData.announcements">
                {{ NewsTitle(news.id) }}
            </div>
            <a routerLink="/announcements" class="all-announcements">
                Tüm Duyurular
                <i class="bi bi-arrow-right">
                </i>
            </a>
        </section>
    </div>
</ng-container>
<app-dashboard-loader
    [errorMessage]="dashboardErrorMessage"
    homeUrl="/"
    loginUrl="/login"
>
</app-dashboard-loader>
<app-dashboard-error
    [errorMessage]="dashboardErrorMessage"
    homeUrl="/"
    (loginRequested)="GoToLogin()"
></app-dashboard-error>